import * as squint_core from 'squint-cljs/core.js';
var copyButtonPlugin = ({"before:highlightElement": (function (p__11334) {
const map___1_3 = p__11334;
const map___1_4 = ((squint_core.truth_(squint_core.sequential_QMARK_(map___1_3))) ? (((squint_core.truth_(squint_core.vector_QMARK_(map___1_3))) ? (map___1_3) : (squint_core.seq_to_map_for_destructuring(map___1_3)))) : (map___1_3));
const el_5 = squint_core.get(map___1_4, "el");
const button_6 = document.createElement("button");
button_6.innerHTML = "copy";
button_6.className = "hljs-copy-button";
button_6.dataset.copied = "false";
const parent_7 = el_5.parentElement;
parent_7.classList.add("hljs-copy-wrapper");
parent_7.appendChild(button_6);
return button_6.addEventListener("click", (function () {
const temp__6897__auto___8 = navigator.clipboard;
if (squint_core.truth_(temp__6897__auto___8)) {
const clipboard_9 = temp__6897__auto___8;
clipboard_9.writeText(el_5.innerText).then((function () {
button_6.innerHTML = "copied";
return button_6.dataset.copied = "true";

}));
return setTimeout((function () {
button_6.innerHTML = "copy";
return button_6.dataset.copied = "false";

}), 2000);
};

}));

})});

export { copyButtonPlugin }
